const Backbone = require('backbone');
const $ = require('jquery');
const _ = require('underscore');
const Obscura = require('backbone.obscura');
const reader = require('../helpers/reader');
const dispatcher = require('../dispatcher');
const jumpTo = require('../templates/jump-to.jade');
const SubtitleScope = require('../scopes/subtitle');
const STATUSES = SubtitleScope.VARIABLES.STATUSES;

require('jquery-ui');

module.exports = Backbone.View.extend({
	el: jumpTo(),

	events: {
		'click .overlay': 'remove',
		'click .cancel': 'remove',
		'change [type="radio"]': 'toggleOptions',
		'keyup .go-to-subtitle': 'jumpToSubtitle',
		'keydown .go-to-time': 'timeControl',
		'click .ok': 'jumpTo'
	},

	autoRender: true,

	initialize: function (options) {
		_.extend(this, options);

		_.bindAll(this, 'jumpTo', 'remove', 'timeControl');

		if (this.autoRender) this.render();
	},

	render: function () {
		this.$('span').html(this.collection.length);
		this.$el.draggable();
		return this;
	},

	toggleOptions: function (e) {
		var $this = $(e.currentTarget);

		$this.siblings('input[type="text"]').prop('disabled', false);
		$this.parents('.row').siblings('.row').find('input[type="text"]').prop('disabled', true);
	},

	jumpToSubtitle: function (e) {
		var $this = $(e.currentTarget);
		var colLength = this.collection.length;

		if ($this.val() > colLength) 
			$this.val(colLength);

		if (e.keyCode == 13) this.jumpTo();
	},

	timeControl: function (e) {
		var keyCode = e.keyCode;

		if (keyCode < 37 || keyCode > 40) e.preventDefault();

		if (keyCode == 38 || keyCode == 40) this.arrowTimeControl(e);
		else if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) this.keyboardTimeControl(e);
	},

	arrowTimeControl: function (e) {
		e.preventDefault();

		var $el = $(e.currentTarget);
		var elValue = $el.val();
		var currentFrame = reader.convertToFrames(elValue, true);
		var frameRate = this.collection.first().getCurrentModel().get('frameRate');

		var caret = e.currentTarget.selectionStart;
		var dataSetPosition = Math.floor(caret / 3);

		var value, limitFrame, increment;

		var isHour = dataSetPosition === 0;
		var isMinute = dataSetPosition === 1;
		var isSecond = dataSetPosition === 2;
		var isFrame = dataSetPosition === 3;

		if (isFrame) increment = 1;
		else if (isSecond) increment = frameRate;
		else if (isMinute) increment = frameRate * 60;
		else if (isHour) increment = frameRate * 60 * 60;

		if (e.shiftKey) increment *= 10;

		if (e.keyCode == 38) { //up
			limitFrame = this.collection.last().getCurrentModel().get('frameEnd');

			value = currentFrame + increment;
			if (value >= limitFrame) value = limitFrame;

		} else { // down
			value = currentFrame - increment;
		}

		$el.val(reader.convertToTime(value));

		e.currentTarget.selectionStart = dataSetPosition * 3;
		e.currentTarget.selectionEnd = dataSetPosition * 3 + 2;
	},

	keyboardTimeControl: function (e) {
		String.prototype.replaceAt = function (index, character) {
			return this.substr(0, index) + character + this.substr(index + character.length);
		};

		var $el = $(e.currentTarget);
		var elValue = $el.val();
		var frameRate = this.collection.first().getCurrentModel().get('frameRate');

		var keyPressed = String.fromCharCode(e.keyCode);
		var caret = e.currentTarget.selectionStart;
		if (caret % 3 == 2) caret += 1;

		var dataSetPosition = Math.floor(caret / 3);

		var isMinute = dataSetPosition === 1;
		var isSecond = dataSetPosition === 2;
		var isFrame = dataSetPosition === 3;

		var value = elValue.replaceAt(caret, keyPressed);

		var timeString = value.split('.')[0];
		var frames = value.split('.')[1];

		var times = timeString.split(':');

		if (times[2] >= 60 && isSecond) {
			times[2] = '59';
		} else if (times[1] >= 60 && isMinute) {
			times[1] = '59';
		}

		if (frames >= frameRate && isFrame) {
			frames = '24';
		}

		value = times.join(':') + '.' + frames;

		var currentFrame = reader.convertToFrames(value, true);

		var limitFrameModel, limitFrameSubtitle;

		limitFrameModel = this.collection.last().getCurrentModel().get('frameEnd');

		if (currentFrame >= limitFrameModel) currentFrame = limitFrameModel;

		value = reader.convertToTime(currentFrame);

		$el.val(value);

		e.currentTarget.selectionStart = caret + 1;
		e.currentTarget.selectionEnd = caret + 1;
	},

	jumpTo: function () {
		var $input = this.$('input[type="text"]').not(':disabled');
		var index = -1;
		var val = $input.val();

		if (val == 0) return;

		if ($input.hasClass('go-to-time')) {
			var frame = reader.convertToFrames($input.val());
			var proxy = new Obscura(this.collection);

			proxy.filterBy(function (model) {
				return model.getCurrentModel().get('frameStart') <= frame && frame <= model.getCurrentModel().get('frameEnd')
			});

			if (proxy.length) {
				index = this.collection.indexOf(proxy.first());
				
				// Jump to the exact time entered, not just the start of the subtitle
				var exactTime = reader.framesToTime(frame);
				dispatcher.emit(dispatcher.events.REQUEST_PLAY_TIME_CHANGE, exactTime);
			}
		} else {
			index = $input.val();
			index -= 1;
		}

		var notDeletedItemsCollection = this.collection && 
			this.collection.filter(item => item.attributes.status != STATUSES.DELETED);
		var model = notDeletedItemsCollection[index];

		if (model) {
			dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
			dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, index);
			dispatcher.emit(dispatcher.events.SCROLL_TO, index);
			
			// Only call PLAY_SUBTITLE for subtitle navigation, not time navigation
			if (!$input.hasClass('go-to-time')) {
				dispatcher.emit(dispatcher.events.PLAY_SUBTITLE, model, 0);
			}
		}

		this.remove();
	},

	remove: function () {
		dispatcher.emit(dispatcher.events.ENABLE_KEYBOARD_CONTROLS);

		Backbone.View.prototype.remove.apply(this, arguments);
	}
});


// WEBPACK FOOTER //
// ./app/views/jump-to.js